import ValidatedField from "@/validation/ValidatedField";
import ValidatedForm from "@/validation/ValidatedForm";
import Rpc from "@/Rpc"


export default class OrganizationForm extends ValidatedForm {
    constructor() {
        super();

        this.loginPageImage = new ValidatedField(this, null);
        this.navigationBarImage = new ValidatedField(this, null);
        this.name = new ValidatedField(this, "");
        this.shortName = new ValidatedField(this, "", Rpc.Validators.validateShorterOptionalText);
        this.fullName = new ValidatedField(this, "", Rpc.Validators.validateShortOptionalText);
        this.setLabels();
    }

    async editOrganization() {
        let organization = await Rpc.OrganizationSetup.getSessionOrganizationInfo().lock();
        super.editMode(organization, "EDIT_AS_ADMIN");
    }

    async refresh(){
        let organization = await Rpc.OrganizationSetup.getSessionOrganizationInfo();
        super.fillValuesFrom(organization);
    }

    async saveOrganization(){
        try {
            this.populateValuesTo(this.originalSource);
            let organization = this.populateValuesTo(this.originalSource);
            await Rpc.OrganizationSetup.editMyOrganization(organization);
        }
        catch(e) {
            this.parseException(e);
        }
    }


}